import { Pipe, PipeTransform, inject } from '@angular/core';
import { LDFlagSet } from 'launchdarkly-js-client-sdk';
import { distinctUntilChanged, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureFlagsService } from '../feature-flags.service';

/**
 * @deprecated Use FeatureFlagSignalPipe instead. Signal pipes are more performant and easier to use.
 */
@Pipe({
  name: 'featureFlagPure',
  standalone: false,
})
export class FeatureFlagPurePipe implements PipeTransform {
  private readonly featureFlagsService = inject(FeatureFlagsService);

  transform(value: string): Observable<boolean> {
    return this.featureFlagsService.flag$.pipe(
      map((flags: LDFlagSet) => flags[value]),
      distinctUntilChanged(),
    );
  }
}
